var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-xs font-semibold inline-block py-1 px-2 uppercase rounded text-indigo-600 bg-indigo-200 uppercase last:mr-0 m-1 "},[_vm._v("\n  "+_vm._s(_vm.tag)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }